import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Terminal, Cpu, Network, Zap, ShieldCheck, Activity } from "lucide-react";
const systemMetrics = [{
  id: 1,
  label: "MATCH_SPEED",
  value: "< 1.8s"
}, {
  id: 2,
  label: "COST_REDUCTION",
  value: "50.0%"
}, {
  id: 3,
  label: "PROTOCOL",
  value: "P2P_FOOD"
}];
export default function AITechPackDevelopment() {
  return <section data-section-id="116222" id="the-logic-of-half" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{
      backgroundImage: 'linear-gradient(to right, #ffffff 1px, transparent 1px), linear-gradient(to bottom, #ffffff 1px, transparent 1px)',
      backgroundSize: '3rem 3rem'
    }} />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          
          {}
          <div className="lg:col-span-7 space-y-10">
            <div className="space-y-6">
              <div className="flex items-center gap-3 font-mono text-[10px] tracking-[0.2em] text-primary uppercase">
                <span className="flex size-2 rounded-full bg-primary animate-pulse" />
                System Status: Operational_V2
              </div>
              
              <h2 className="text-6xl sm:text-7xl lg:text-8xl font-black tracking-tighter leading-[0.9] uppercase italic">
                Split Food. <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-primary to-orange-400">
                  Pay Half.
                </span>
              </h2>

              <p className="text-muted-foreground text-lg sm:text-xl max-w-xl leading-relaxed font-medium">
                Split meals with people around you, save money, and enjoy more food for less. HalfOrder connects nearby users so you can share orders instead of paying full price alone.
              </p>
            </div>

            {}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 border border-white/10 bg-white/5 backdrop-blur-md p-6 rounded-sm">
              {systemMetrics.map((metric, i) => <div key={metric.id} data-index={i} className="space-y-1">
                  <div className="text-[10px] font-mono text-zinc-500 uppercase tracking-widest">{metric.label}</div>
                  <div className="text-lg font-mono font-bold text-foreground">{metric.value}</div>
                </div>)}
            </div>

            <div className="flex flex-wrap items-center gap-6">
              <Link to="/HowItWorksPage">
                <Button size="lg" className="rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 h-14 px-10 font-mono uppercase tracking-widest text-sm transition-all duration-300 shadow-[0_0_20px_rgba(249,115,22,0.3)] border-none">
                  <Terminal className="size-4 mr-2" />
                  Initialize Split
                </Button>
              </Link>
              <div className="flex items-center gap-4 text-zinc-500 font-mono text-[10px] uppercase tracking-widest">
                <div className="flex items-center gap-1.5">
                  <ShieldCheck className="size-3 text-primary" />
                  Secure
                </div>
                <div className="flex items-center gap-1.5">
                  <Activity className="size-3 text-primary" />
                  Live
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative">
            <div className="relative z-20 group">
              {}
              <div className="absolute -inset-4 border border-white/5 rounded-sm pointer-events-none group-hover:border-primary/20 transition-colors duration-500" />
              
              <div className="relative bg-zinc-900/50 border border-white/10 rounded-sm overflow-hidden backdrop-blur-xl">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-50" />
                
                <AspectRatio ratio={4 / 5} className="relative">
                  <div className="absolute inset-0 w-full h-[2px] bg-primary/30 shadow-[0_0_20px_rgba(249,115,22,0.4)] animate-[scan_6s_linear_infinite] z-30" />
                  
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/halforder_logic_blueprint.png" alt="HalfOrder Split Architecture" className="w-full h-full object-cover opacity-40 group-hover:opacity-60 transition-opacity duration-700 grayscale contrast-125" />

                  {}
                  <div className="absolute inset-0 p-6 flex flex-col justify-between pointer-events-none">
                    <div className="flex justify-between items-start">
                      <div className="space-y-1">
                        <div className="bg-primary/20 text-primary text-[8px] font-mono px-2 py-0.5 rounded-full border border-primary/30">
                          NODE_ACTIVE
                        </div>
                        <div className="text-[10px] font-mono text-white/40">TOR_GTA_CORE</div>
                      </div>
                      <Cpu className="size-5 text-primary/50" />
                    </div>

                    <div className="space-y-4">
                      <div className="h-[1px] w-full bg-gradient-to-r from-primary/50 to-transparent" />
                      <div className="flex justify-between items-end font-mono text-[10px]">
                        <div className="text-white/40">
                          <div>LAT: 43.6532 N</div>
                          <div>LON: 79.3832 W</div>
                        </div>
                        <div className="text-right text-primary">
                          <div>SAVINGS_MAX: 50%</div>
                          <div>EFFICIENCY: 0.99</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </AspectRatio>
              </div>
            </div>

            {}
            <div className="absolute -top-10 -right-10 size-40 bg-primary/5 rounded-full blur-3xl pointer-events-none" />
            <div className="absolute -bottom-10 -left-10 size-40 bg-orange-500/5 rounded-full blur-3xl pointer-events-none" />
          </div>

        </div>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes scan {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(1100%); }
        }
      `
    }} />
    </section>;
}